import React from "react";
import { useNavigate } from "react-router-dom";

const Help = () => {
  const navigate = useNavigate();
  const vidiVodic = () => navigate("/vodic");

  return (
    <div className="container mx-auto p-6 max-w-7xl text-gray-800">
      <h1 className="text-3xl font-bold text-center mb-6">Pomoć</h1>

      <nav className="mb-6 p-4 bg-gray-100 rounded-lg shadow">
        <ul className="space-y-2">
          <li>
            <a href="#faq" className="text-blue-600 hover:underline">
              1. Često postavljena pitanja (FAQ)
            </a>
          </li>
          <li>
            <a href="#kontaktinf" className="text-blue-600 hover:underline">
              2. Kontaktirajte nas ili Kontakt informacije
            </a>
          </li>
          <li>
            <a href="#vodic" className="text-blue-600 hover:underline">
              3. Korisnički vodič
            </a>
          </li>
          <li>
            <a href="#podrska" className="text-blue-600 hover:underline">
              4. Podrška ili Tehnička podrška
            </a>
          </li>
          <li>
            <a href="#mapa" className="text-blue-600 hover:underline">
              5. Mapa sajta ili Navigacija
            </a>
          </li>
        </ul>
      </nav>

      <div className="bg-white shadow-lg rounded-lg p-6 border border-gray-200 overflow-y-auto h-screen">
        <h2 id="faq" className="text-md font-semibold text-gray-900 mb-4">
          1. Često postavljena pitanja (FAQ)
        </h2>
        <p className="mb-4">
          Dobrodošli u NutriTrans FAQ sekciju! Ovdje ćete pronaći odgovore na
          najčešće postavljena pitanja o našim uslugama i proizvodima. Ako ne
          pronađete odgovor koji tražite, slobodno nas kontaktirajte.
        </p>

        <h2
          id="faqPodnaslov"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          SADRŽAJ
        </h2>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>Šta je NutriTrans?</li>
          <li>Kako se registrirati na NutriTrans platformu?</li>
          <li>Da li je NutriTrans besplatan za korišćenje?</li>
          <li>Kako funkcioniše praćenje nutritivnih vrijednosti?</li>
          <li>Mogu li prilagoditi svoj nutritivni plan?</li>
          <li>Kako mogu resetovati svoju lozinku?</li>
          <li>Koji su načini plaćanja dostupni?</li>
          <li>Kako mogu otkazati svoju pretplatu?</li>
          <li>Da li su moji podaci sigurni?</li>
          <li>Kako mogu kontaktirati korisničku podršku?</li>
        </ol>

        <h2
          id="faqPodnaslov1"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          1. Šta je NutriTrans?
        </h2>

        <p className="mb-4">
          <strong>Odgovor:</strong> NutriTrans je digitalna platforma
          dizajnirana za praćenje i upravljanje vašim nutritivnim unosom.
          Pružamo alate koji vam pomažu da razumijete svoje prehrambene navike,
          postavite ciljeve i pratite svoj napredak ka zdravijem načinu života.
        </p>

        <h2
          id="faqPodnaslov2"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          2. Kako se registrirati na NutriTrans platformu?
        </h2>

        <p className="mb-4">
          <strong>Odgovor:</strong>Registracija je jednostavna:
        </p>

        <ol className="mb-4">
          <li>
            1. Kliknite na dugme <strong>"Registracija"</strong> u gornjem
            desnom uglu početne stranice.
          </li>
          <li>
            2. Unesite svoje osnovne informacije: email adresu i kreirajte
            lozinku.
          </li>
          <li>
            3. Potvrdite svoju email adresu klikom na link koji ćemo vam
            poslati.
          </li>
          <li>
            4. Nakon potvrde, prijavite se i započnite s korištenjem
            NutriTransa.
          </li>
        </ol>

        <h2
          id="faqPodnaslov3"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          3. Da li je NutriTrans besplatan za korištenje?
        </h2>

        <p className="mb-4">
          <strong>Odgovor:</strong> NutriTrans nudi osnovnu verziju koja je
          potpuno besplatna i omogućava vam osnovno praćenje unosa hrane i
          aktivnosti. Također nudimo Premium pretplatu koja uključuje napredne
          funkcije kao što su personalizirani planovi ishrane, detaljne analize
          i pristup stručnim savetima.
        </p>

        <h2
          id="faqPodnaslov4"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          4. Kako funkcioniše praćenje nutritivnih vrijednosti?
        </h2>

        <p className="mb-4">
          <strong>Odgovor:</strong> Nakon što unesete hranu koju ste
          konzumirali:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            Naša baza podataka prepoznaje hranu i automatski izračunava
            nutritivne vrijednosti poput kalorija, proteina, masti i
            ugljikohidrata.
          </li>
          <li>Možete ručno dodati hranu ako nije dostupna u našoj bazi.</li>
          <li>
            Pratite svoj dnevni unos kroz interaktivne grafikone i izvještaje.
          </li>
        </ul>

        <h2
          id="faqPodnaslov5"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          5. Mogu li prilagoditi svoj nutritivni plan?
        </h2>

        <p className="mb-4">
          <strong>Odgovor:</strong>Da, NutriTrans omogućava personalizaciju
          vašeg nutritivnog plana:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            Postavite svoje ciljeve (gubitak težine, povećanje mišićne mase,
            održavanje težine).
          </li>
          <li>Unesite svoje prehrambene preferencije i eventualne alergije.</li>
          <li>
            Naša platforma će generirati plan ishrane prilagođen vašim
            potrebama.
          </li>
        </ul>

        <h2
          id="faqPodnaslov6"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          6. Kako mogu resetovati svoju lozinku?
        </h2>

        <p className="mb-4">
          <strong>Odgovor:</strong>
        </p>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>
            Na stranici za prijavu kliknite na link "Zaboravljena lozinka?".
          </li>
          <li>Unesite email adresu povezanu s vašim računom.</li>
          <li>
            Provjerite svoj email i slijedite upute za resetiranje lozinke.
          </li>
        </ol>

        <h2
          id="faqPodnaslov7"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          7. Koji su načini plaćanja dostupni?
        </h2>

        <p className="mb-4">
          <strong>Odgovor:</strong>Prihvatamo sljedeće načine plaćanja: work
          here
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            Kreditne i debitne kartice (Visa, MasterCard, American Express)
          </li>
          <li>Bankovni transferi (za godišnje pretplate)</li>
          <li>PayPal</li>
          <li>Napomena: Sve transakcije su sigurne i enkriptirane.</li>
        </ul>

        <h2
          id="faqPodnaslov8"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          8. Kako mogu resetovati svoju lozinku?
        </h2>

        <p className="mb-4">
          <strong>Odgovor:</strong>
        </p>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>Prijavite se na svoj račun i idite na "Postavke računa".</li>
          <li>Kliknite na "Pretplate".</li>
          <li>Odaberite opciju "Otkazati pretplatu".</li>
          <li>Slijedite upute za potvrdu otkazivanja.</li>
          <li>
            Napomena: Nakon otkazivanja, i dalje ćete imati pristup Premium
            funkcijama do kraja plaćenog perioda.
          </li>
        </ol>

        <h2
          id="faqPodnaslov9"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          9. Da li su moji podaci sigurni?
        </h2>

        <p className="mb-4">
          <strong>Odgovor:</strong>Vaša privatnost nam je od najveće važnosti:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            Koristimo napredne sigurnosne mjere za zaštitu vaših podataka.
          </li>
          <li>Vaši podaci su enkriptirani tokom prijenosa i skladištenja.</li>
          <li>
            Ne dijelimo vaše lične informacije s trećim stranama bez vašeg
            pristanka.
          </li>
          <li>Više detalja pronađite u našoj Politici privatnosti.</li>
        </ul>

        <h2
          id="faqPodnaslov10"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          10. Da li su moji podaci sigurni?
        </h2>

        <p className="mb-4">
          <strong>Odgovor: </strong>Naš tim za podršku stoji vam na
          raspolaganju:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>Email: support@nutritrans.com</li>
        </ul>

        <h2
          id="faqPodnaslov11"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          DODATNE INFORMACIJE
        </h2>

        <p className="mb-4">
          <strong>Kako koristiti ovu FAQ sekciju:</strong>
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Pretraga po ključnim riječima:</strong>Koristite funkciju
            pretrage vašeg preglednika (Ctrl+F ili Cmd+F) za brzi pronalazak
            informacija.
          </li>
          <li>
            <strong>Redovna ažuriranja:</strong>Ova sekcija se redovno ažurira.
            Provjerite najnovija pitanja i odgovore za najaktuelnije
            informacije.
          </li>
        </ul>

        <p className="mb-4">
          <strong>Niste pronašli odgovor koji tražite?</strong>
        </p>

        <p className="mb-4">
          Ako vaše pitanje nije obuhvaćeno ovdje, molimo vas da nas kontaktirate
          putem:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Emaila:</strong>office@nutritrans.com
          </li>
        </ul>

        <h2
          id="faqPodnaslov13"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          PODELITE SVOJE MIŠLJENJE
        </h2>

        <p className="mb-4">
          Vaše povratne informacije su nam važne. Ako imate prijedloge kako
          možemo poboljšati našu uslugu ili FAQ sekciju, pošaljite nam svoje
          mišljenje putem Feedback forme.
        </p>

        <h2
          id="faqPodnaslov14"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          Kontakt
        </h2>

        <p className="mb-4">
          Ako imate dodatnih pitanja ili trebate pomoć, slobodno nas
          kontaktirajte:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Emaila:</strong>office@nutritrans.com
          </li>
        </ul>

        <h2
          id="kontaktinf"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          2. Kontaktirajte nas ili Kontakt informacije
        </h2>
        <p className="mb-4">
          Mi u <strong>NutriTransu</strong> cijenimo vaše mišljenje i uvijek smo
          tu da vam pomognemo. Ako imate pitanja, trebate podršku ili želite
          podijeliti povratne informacije, slobodno nas kontaktirajte putem
          sljedećih kanala:
        </p>

        <h2
          id="kontaktinf1"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          KONTAKT INFORMACIJE
        </h2>

        <p className="mb-4">
          <strong>Tehnička podrška:</strong> support@nutritrans.com
        </p>

        <h2
          id="kontaktinf3"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          Društvene mreže
        </h2>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Facebook:</strong>{" "}
            <a
              href="https://www.facebook.com/nutritrans"
              target="_blank"
              style={{ color: "blue", textDecoration: "none" }}
            >
              facebook.com/nutritrans
            </a>
          </li>
          <li>
            <strong>Instagram:</strong>{" "}
            <a
              href="https://www.instagram.com/nutritrans"
              target="_blank"
              style={{ color: "blue", textDecoration: "none" }}
            >
              @nutritrans
            </a>
          </li>
          <li>
            <strong>Twitter:</strong>{" "}
            <a
              href="https://twitter.com/nutritrans"
              target="_blank"
              style={{ color: "blue", textDecoration: "none" }}
            >
              @nutritrans
            </a>
          </li>
          <li>
            <strong>LinkedIn:</strong>{" "}
            <a
              href="https://www.linkedin.com/company/nutritrans"
              target="_blank"
              style={{ color: "blue", textDecoration: "none" }}
            >
              NutriTrans
            </a>
          </li>
        </ul>

        <p className="mb-4">
          Pratite nas na društvenim mrežama za najnovije vesti, savete i
          ažuriranja.
        </p>

        <h2
          id="kontaktinf4"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          POMOĆ I PODRŠKA
        </h2>

        <p className="mb-4">
          <strong>Često postavljena pitanja (FAQ)</strong>
        </p>

        <p className="mb-4">
          Možda ćete pronaći odgovor na svoje pitanje u našoj FAQ sekciji.
        </p>

        <p className="mb-4">
          <strong>Vodič za korisnike</strong>
        </p>

        <p className="mb-4">
          Za detaljne upute o korištenju naše platforme, posjetite Vodič za
          korisnike.
        </p>

        <h2
          id="kontaktinf5"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          PODIJELITE SVOJE MIŠLJENJE
        </h2>

        <p className="mb-4">
          Vaše povratne informacije su nam dragocjene. Pomozite nam da
          poboljšamo naše usluge:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Anketa zadovoljstva korisnika:</strong>Kliknite ovdje da
            popunite kratku anketu.
          </li>
          <li>
            <strong>Recenzije:</strong> Podijelite svoje iskustvo na našoj
            Recenzije stranici
          </li>
        </ul>

        <h2
          id="kontaktinf6"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          PRIJAVA PROBLEMA
        </h2>

        <p className="mb-4">
          Ako naiđete na tehničke poteškoće ili imate problema s korištenjem
          naše platforme:
        </p>

        <ol className="mb-4">
          <li>
            <strong>Email:</strong> Pošaljite detaljan opis problema na
            support@nutritrans.com.
          </li>
          <li>
            <strong>Snimke ekrana:</strong>Ako je moguće, priložite snimke
            ekrana koji prikazuju problem.
          </li>
          <li>
            <strong>Informacije o uređaju:</strong> Navedite koji uređaj i
            preglednik koristite.
          </li>
        </ol>

        <p className="mb-4">
          Naš tim za podršku će vam se javiti u najkraćem mogućem roku.
        </p>

        <h2
          id="kontaktinf8"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          PRAVNA PITANJA
        </h2>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Politika privatnosti:</strong> Saznajte više
          </li>
          <li>
            <strong>Uslovi korištenja:</strong> Pročitajte ovdje
          </li>
        </ul>

        <p className="mb-4">
          <strong>Hvala što koristite NutriTrans!</strong> Vaše zdravlje i
          zadovoljstvo su nam na prvom mjestu. Radujemo se vašem javljanju.
        </p>

        <h2 id="vodic" className="text-md font-semibold text-gray-900 mb-4">
          3. Korisnički vodič
        </h2>
        <p className="mb-4">
          Dokument{" "}
          <strong
            onClick={vidiVodic}
            className="text-blue-500 cursor-pointer hover:underline"
          >
            “Korisnički vodic za NutriTrans”
          </strong>{" "}
          koji ste primili putem emaila prilikom registracije.
        </p>

        <h2 id="podrska" className="text-md font-semibold text-gray-900 mb-4">
          4. Podrška ili Tehnička podrška
        </h2>

        <p className="mb-4">
          NutriTrans je dizajniran da bude jednostavan i intuitivan za
          korišćenje, ali ako naiđete na bilo kakve probleme ili imate pitanja,
          tu smo da vam pomognemo! Ova sekcija vam pruža informacije o tome kako
          možete dobiti podršku i rešiti eventualne tehničke poteškoće.
        </p>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>
            <strong>Gde možete pronaći pomoć?</strong>
          </li>
          <p className="mb-4">
            NutriTrans platforma nudi više načina podrške kako biste što brže
            dobili odgovore na svoja pitanja. Možete pronaći pomoć kroz sledeće
            kanale:
          </p>
          <p className="mb-4">📌 Sekcija "Pomoć" (FAQ)</p>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>
              U gornjem meniju pronaći ćete sekciju <strong>Pomoć</strong>, gde
              su dostupni odgovori na najčešće postavljana pitanja.
            </li>
            <li>
              U ovoj sekciji ćete pronaći vodiče o tome kako da se registrujete,
              otkažete pretplatu, koristite kalkulatore i planove ishrane.
            </li>
          </ul>
          <li>
            <strong>Kontaktiranje tehničke podrške</strong>
          </li>
          <p className="mb-4">
            Ako niste pronašli odgovor u sekciji "Pomoć", možete direktno
            kontaktirati tehničku podršku putem:
          </p>
          <p className="mb-4">
            ✉️ <strong>Email podrške</strong> – Pošaljite nam email sa svojim
            pitanjem i odgovorićemo u najkraćem roku.
          </p>
          <li>
            <strong>Rešavanje tehničkih problema</strong>
          </li>
          <p className="mb-4">
            Ako naiđete na tehničke poteškoće, pokušajte sledeće korake pre nego
            što kontaktirate podršku:
          </p>
          <p className="mb-4">
            🔄 Osvežite stranicu – Ponekad jednostavno osvežavanje može rešiti
            problem.
          </p>
          <p className="mb-4">
            🧹 Obrišite keš i kolačiće – Ako stranica ne radi kako treba,
            pokušajte da obrišete keš memoriju vašeg pretraživača.
          </p>
          <p className="mb-4">
            🛰️ Proverite internet konekciju – Uverite se da ste povezani na
            stabilnu mrežu.
          </p>
          <p className="mb-4">
            📱 Ažurirajte aplikaciju – Ako koristite mobilnu verziju, proverite
            da li imate najnoviju verziju aplikacije.
          </p>
          <li>
            <strong>Kako prijaviti problem?</strong>
          </li>
          <p className="mb-4">
            Ako problem i dalje postoji, prijavite ga kroz naš sistem podrške:
          </p>
          <ol className="list-decimal pl-6 space-y-2 mb-4">
            <li>
              Idite na sekciju <strong>"Pomoć"</strong> u glavnom meniju.
            </li>
            <li>
              Kliknite na <strong>"Prijavi problem"</strong>.
            </li>
            <li>
              Opisno unesite detalje problema (npr. "Ne mogu da se prijavim na
              nalog").
            </li>
            <li>
              Priložite snimak ekrana ako je moguće – to će pomoći timu za
              podršku da brže reši problem.
            </li>
            <li>
              Kliknite <strong>"Pošalji"</strong> i sačekajte odgovor tima.
            </li>
          </ol>
          <li>
            <strong>Koliko brzo mogu očekivati odgovor?</strong>
          </li>
          <p className="mb-4">
            <strong>Email podrška:</strong> odgovor u roku od{" "}
            <strong>24 sata</strong>.
          </p>
          <p className="mb-4">⏳ Radno vreme tehničke podrške:</p>
          <p className="mb-4">📅 Pon-Pet: 08:00 - 20:00</p>
          <p className="mb-4">📅 Subota: 09:00 - 15:00</p>
          <p className="mb-4">📅 Nedelja: Odmor (ali možete poslati email).</p>
        </ol>

        <h2 id="mapa" className="text-md font-semibold text-gray-900 mb-4">
          5. Mapa sajta ili Navigacija
        </h2>

        <p className="mb-4">
          <strong>
            Ako problem i dalje postoji, prijavite ga kroz naš sistem podrške:
          </strong>
        </p>

        <p className="mb-4">
          <i>
            (Prikazuje sve sekcije sajta i aplikacije u hijerarhijskoj
            strukturi)
          </i>
        </p>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>
            <strong>Početna stranica</strong>
          </li>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Uvod o NutriTrans aplikaciji</li>
            <li>Ključne funkcionalnosti</li>
            <li>Dugmad za registraciju i prijavu</li>
          </ul>
          <li>
            <strong>O nama</strong>
          </li>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Misija i vizija</li>
            <li>Tim stručnjaka</li>
            <li>Kontakt informacije</li>
          </ul>

          <li>
            <strong>Registracija i Prijava</strong>
          </li>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Kreiranje naloga</li>
            <li>Prijava u aplikaciju</li>
            <li>Resetovanje lozinke</li>
          </ul>

          <li>
            <strong>Korisnički profil</strong>
          </li>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Podešavanje ličnih podataka</li>
            <li>Zdravstveni parametri</li>
            <li>Postavljeni ciljevi</li>
            <li>Istorija napretka</li>
          </ul>

          <li>
            <strong>Planovi ishrane</strong>
          </li>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Personalizovani izveštaji</li>
            <li>Preporuke na osnovu ciljeva</li>
            <li>Baza namirnica i nutritivne vrednosti</li>
          </ul>

          <li>
            <strong>Fizička aktivnost</strong>
          </li>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Preporučene vežbe</li>
            <li>Programi aktivnosti</li>
            <li>Praćenje napretka</li>
          </ul>

          <li>
            <strong>Blog i edukacija</strong>
          </li>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Saveti o zdravoj ishrani</li>
            <li>Fitnes i zdravlje</li>
            <li>Nutricionistički mitovi</li>
          </ul>

          <li>
            <strong>Kalkulatori i alati</strong>
          </li>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>BMI kalkulator</li>
            <li>BMR i TDEE kalkulator</li>
            <li>Dnevni unos kalorija</li>
          </ul>

          <li>
            <strong>Pretplata i cene</strong>
          </li>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Besplatna verzija</li>
            <li>Premium paketi</li>
            <li>Načini plaćanja</li>
          </ul>

          <li>
            <strong>Podrška i Pomoć</strong>
          </li>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Često postavljana pitanja (FAQ)</li>
            <li>Korisnički vodič</li>
            <li>Kontaktirajte podršku</li>
          </ul>

          <li>
            <strong>Pravni dokumenti</strong>
          </li>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Uslovi korišćenja</li>
            <li>Politika privatnosti</li>
            <li>Prava korisnika</li>
          </ul>
        </ol>

        <h2 className="text-md font-semibold text-gray-900 mb-4">
          Navigacija (Glavni meni sajta/aplikacije)
        </h2>

        <p className="mb-4">
          <i>
            (Kako će izgledati gornji meni ili bočna navigacija aplikacije i
            sajta)
          </i>
        </p>

        <p className="mb-1">
          📌 <strong>Glavni meni:</strong>
        </p>
        <p className="mb-1">
          ✅ <strong>Početna</strong>
        </p>
        <p className="mb-1">
          ✅ <strong>Moj profil</strong>
        </p>
        <p className="mb-1">
          ✅ <strong>Planovi ishrane</strong>
        </p>
        <p className="mb-1">
          ✅ <strong>Fizička aktivnost</strong>
        </p>
        <p className="mb-1">
          ✅ <strong>Blog</strong>
        </p>
        <p className="mb-1">
          ✅ <strong>Kalkulatori</strong>
        </p>
        <p className="mb-1">
          ✅ <strong>Pretplata</strong>
        </p>
        <p className="mb-1">
          ✅ <strong>Podrška</strong>
        </p>

        <br />

        <p className="mb-1">
          📌 <strong>Sekcije unutar korisničkog profila:</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Osnovni podaci</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Moji ciljevi</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Napredak i statistika</strong>
        </p>

        <br />

        <p className="mb-1">
          📌 <strong>Sekcije unutar planova ishrane:</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Dnevni jelovnik</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Moje omiljene namirnice</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Saveti o ishrani</strong>
        </p>

        <br />

        <p className="mb-1">
          📌 <strong>Sekcije unutar fizičke aktivnosti:</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Vežbe prema cilju</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Moji treninzi</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Istorija aktivnosti</strong>
        </p>

        <br />

        <p className="mb-1">
          📌 <strong>Sekcije unutar bloga:</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Najnoviji članci</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Kategorije (ishrana, fitnes, zdravlje)</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Pretraga bloga</strong>
        </p>

        <br />

        <p className="mb-1">
          📌 <strong>Sekcije unutar kalkulatora:</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>BMI</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>BMR & TDEE</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Kalorijski unos</strong>
        </p>

        <br />

        <p className="mb-1">
          📌 <strong>Sekcije unutar pravnih dokumenata:</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Uslovi korišćenja</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Politika privatnosti</strong>
        </p>
        <p className="mb-1">
          ➡️ <strong>Kontakt</strong>
        </p>

        {/* work here */}
      </div>
    </div>
  );
};

export default Help;
